<script setup>
import { TransitionRoot, TransitionChild, Dialog, DialogPanel } from '@headlessui/vue'
import { useBillingStore } from '@/stores/BillingStore'
import { useConfigStore } from '@/stores/ConfigStore'

const emit = defineEmits(['close'])

const billingStore = useBillingStore()
const configStore = useConfigStore()

const handleClose = () => {
  configStore.fetchConfigs()
  billingStore.upgradePlanSuccessModal = false
  billingStore.upgradeFeatureModal = false
  billingStore.upgradeWindow = false
  emit('close')
}
</script>

<template>
  <TransitionRoot as="template" :show="billingStore.upgradePlanSuccessModal">
    <Dialog as="div" class="relative z-[9999]" @close="handleClose">
      <TransitionChild
        as="template"
        enter="ease-out duration-300"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="ease-in duration-200"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div class="fixed inset-0 bg-black bg-opacity-[0.38] transition-opacity backdrop-blur-sm" />
      </TransitionChild>

      <div class="fixed inset-0 z-10 overflow-y-auto">
        <div class="flex min-h-full w-full justify-center items-center p-4 md:p-[30px]">
          <TransitionChild
            as="template"
            enter="ease-out duration-300"
            enter-from="opacity-0 translate-y-4 md:translate-y-0 md:scale-95"
            enter-to="opacity-100 translate-y-0 md:scale-100"
            leave="ease-in duration-200"
            leave-from="opacity-100 translate-y-0 md:scale-100"
            leave-to="opacity-0 translate-y-4 md:translate-y-0 md:scale-95"
          >
            <DialogPanel class="relative rounded-lg bg-white px-6 py-10 shadow-xl transition-all w-full max-w-md text-center">
              <div class="flex flex-col items-center gap-y-6">
                <img src="@/assets/3d-assets/icons/check.png" class="w-[6.5rem]" />
                <h2 class="text-base font-medium text-gray-900">Your plan has been updated!</h2>
                <button
                  class="alternative-button w-full py-2.5 text-sm"
                  @click="handleClose"
                >
                  Back to Card Dealer Pro
                </button>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>
